
import { DateRangeModel } from './date-range.model';
import { DateQueryTypeEnum } from '../enum/date-query-type.enum';
import { RelativeTimezoneDateTypeEnum } from '../enum/relative-timezone-date-type.enum';

export class SearchCriteriaDateQueryModel {
    dateType: DateQueryTypeEnum;
    relativeTimezoneDateType?: RelativeTimezoneDateTypeEnum;

    // So, 'yesterday' would have the values [48, 24] here.
    relativeStartOffsetH?: number;
    relativeEndOffsetH?: number;

    absoluteDate?: Date;
    dateRange?: DateRangeModel;

    timeZone?: string;
}
